"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TTL_REFRESH = exports.REFRESH_RATE = exports.DEFAULT_CACHE_SIZE = exports.LOG_PREFIX = void 0;
exports.LOG_PREFIX = 'storage:redis: ';
exports.DEFAULT_CACHE_SIZE = 30000;
exports.REFRESH_RATE = 300000; // 300.000 ms = start after 5 mins
exports.TTL_REFRESH = 3600; // 1hr
